import { getParams } from '@dt/fe-utils'
import { isObject } from '@dt/fe-utils/dist/lodash'
import { getPlatform } from './utils'

/**
 * 设置css3变量
 * @param {string} selector - 元素选择器
 * @param {Record<string, any>} cssMap - 设置的css3变量
 */
export function setCSSProperty (selector: string, cssMap: Record<string, any> = {}) {
  const ele = document.querySelector(selector) as any
  Object.keys(cssMap).forEach((key) => {
      ele?.style?.setProperty?.(key, cssMap[key])
  })
}

/**
 * 路由跳转
 */
export function miniAppRouteTo (option: any) {
  const url = option?.url || option
  const _option = isObject(option) ? option : {}
  const { fromNavigateTo } = getParams()
  const { isWeixinMiniProgram, isAliPayMiniProgram } = getPlatform()
  const miniAppNotNavigateBack = sessionStorage.getItem('ss.miniAppNotNavigateBack')
  const isNavigateBack = fromNavigateTo && !miniAppNotNavigateBack && ['/pages/home/index'].includes(url)

  if (isWeixinMiniProgram) {
    if (isNavigateBack) {
      window?.wx?.miniProgram?.navigateBack({
        fail () {
          window?.wx?.miniProgram?.redirectTo({
            ..._option,
            url
          })
        }
      })
    } else {
      window?.wx?.miniProgram?.redirectTo({
        ..._option,
        url
      })
    }
  } else if (isAliPayMiniProgram) {
    if (isNavigateBack) {
      window?.my?.navigateBack({
        fail () {
          window?.my?.redirectTo({
            ..._option,
            url
          })
        }
      })
    } else {
      window?.my?.redirectTo({
        ..._option,
        url
      })
    }
  }
}
